import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import KhmListPage from "./KhmListPage"

const KhmWorkerISPPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // let manager_role = auth.user.roles.some((obj:any) => ['KHM'].includes(obj.role));

  // const [isp_mode , setIsp_mode] = useState<boolean>(manager_role);

  // const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'KHM_ISP').map((info:any) => info.user_id)[0];   
  
  const [taskSelectPageOpen , setTaskSelectPageOpen] = useState<boolean>(false);
  const [task, setTask] = useState("01");

  const [work_yn, setWork_yn] = useState("모두");

  const [use_check, setUse_check] = useState("모두");

  const [workList, setWorkList] = useState([]);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const goTask = (task: string) => {
    setTask(task);
    kmWorkList(work_yn)
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const kmWorkList = async (work_yn:string) => {
    
    setBackdrop(true)
    api.get('/km-isp-workList',{params:{email:email,page:page,worker:worker,work_yn:work_yn,gub:"isp"}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setWorkList(res.data);
        // setData(res.data.datas[0]);
        setWorkList(res.data);
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setWorkList(res.data);
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  // const getAuth = async () => {
  //   if(!email){ nav('/') }
  //   api.get('/@me',{params:{email:email}})
  //   .then((resp:any) => {dispatch(setUserInfo(resp.data)),console.log('/@me',resp.data) })
  //     // alert("파일 업로드가 완료되었습니다.");
  //   .catch((error:any) => {console.error('에러',error.response);})
  //   // alert("파일 업로드 실패. " + error.response.data.error);
  // }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    // getAuth()
    kmWorkList(work_yn)
  },[page])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>작업할당 목록 (<b style={{color:"#1976d2"}}>{total_cnt != 0 ? total_cnt:0}</b> 건)</Box>
        </Box>
        <Box display="flex" sx={{alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>작업상태</Box>
          <Select id="work_yn" value={work_yn} onChange={(e)=> { setWork_yn(e.target.value); kmWorkList(e.target.value); goPage(1);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"0"}>미작업</MenuItem>
            <MenuItem dense value={"Y"}>적합</MenuItem>
            <MenuItem dense value={"N"}>부적합</MenuItem>
            <MenuItem dense value={"R"}>반려</MenuItem>
          </Select>
        </Box>
        {/* <Box display="flex" sx={{marginLeft: "16px",alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>USE_CHECK</Box>
          <Select id="use_check" value={use_check} onChange={(e)=> { setUse_check(e.target.value); kmWorkList(work_yn,e.target.value,task);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"T"}>사용가능</MenuItem>
            <MenuItem dense value={"C"}>내용수정</MenuItem>
            <MenuItem dense value={"F"}>사용불가</MenuItem>
            <MenuItem dense value={"None"}>미분류</MenuItem>
          </Select>
        </Box> */}
      </Box>
      {/* 상단 메뉴 */}

      {/* Task 단위 화면 */}
      <KhmListPage work_yn={work_yn} setPage={setPage} goPage={goPage} workList={workList} kmWorkList={kmWorkList}/>
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box> */}
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box> */}
      {/* <Box><textarea spellCheck="false" value={"ប្រើពុម្ពអក្សរខ្មែរ"} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "'Noto Sans Khmer', sans-serif"}}  /></Box> */}
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default KhmWorkerISPPage;
